<!-- 使用方法
<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" /> -->

<!--
  total:总页数
  page:当前页数
  limit:一页有多少条数据
  pagination:刷新触发函数
 -->

<template>
    <div class="pagination-container block">
        <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout"
            :page-sizes="pageSizes" :total="total" :popper-class="popperClass" @size-change="handleSizeChange"
            :pager-count="pagerCount" @current-change="handleCurrentChange" v-bind="$attrs" />
    </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      // required: true,
      type: Number
    },
    iDisplayStart: {
      type: Number,
      default: 0
    },
    iDisplayLength: {
      type: Number,
      default: 15
    },
    limit: {
      type: Number,
      default: 15
    },
    pageSizes: {
      type: Array,
      default () {
        return [15, 20, 50, 100]
      }
    },
    pagerCount: {
      type: Number,
      default: 5
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      popperClass: 'popperClass'
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.iDisplayStart
      },
      set (val) {
        const num = (val - 1) * this.pageSize
        this.$emit('update:page', num < 0 ? 0 : num)
      }
    },
    pageSize: {
      get () {
        return this.limit
      },
      set (val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      // this.$emit('update:page', val);
      this.$emit('pagination', { iDisplayStart: this.currentPage, iDisplayLength: val })
    },
    handleCurrentChange (val) {
      this.$emit('update:page', (val - 1) * this.pageSize)
      this.$emit('pagination', { iDisplayStart: (val - 1) * this.pageSize, iDisplayLength: this.pageSize })
    },
    // 设置页码
    setPage (page) {
      this.currentPage = page
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
    background: #fff;
    padding-top: 7px;
    // padding-right: 15px;
    height: 60px;
    box-sizing: border-box;
}

.popperClass {
    height: 30px;
}

.el-pagination {
    padding: 0px;
}

.pagination-container.hidden {
    display: none;
}

::v-deep.el-icon-arrow-left {
    color: var(--primary-color) !important;
}

::v-deep.el-pagination button,
::v-deep.el-pagination span:not([class*='suffix']) {
    height: 36px;
    line-height: 36px;
}

::v-deep.el-pagination.is-background ::v-deep.el-pager li:not(.disabled).active {
    background-color: var(--primary-color) !important;
}

::v-deep.el-pagination.is-background .btn-next,
::v-deep.el-pagination.is-background .btn-prev,
::v-deep.el-pagination.is-background .el-pager li {
    //border-radius: 50% !important;
    height: 30px;
    margin-top: 3px;
}
</style>
